import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {
  cached: {},
}

export const getters = {}

export const mutations = {
  CACHE_COMPANY_INFO(state, companyInfo) {
    state.cached = companyInfo
  },
}

export const actions = {

  init({ state, dispatch }) {},

  fetchCompanyInfo(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/company-info/${query}`).then((response) => {
      const results = response.data.results
      if (results.length){
        const compInfo = results[results.length - 1]
        context.commit('CACHE_COMPANY_INFO', compInfo)
        return compInfo
      }else{
        return {}
      }
    })
  },

  createUpdateCompanyInfo(context, formData) {
    let promise = null
    if (formData.url){
      promise =  axios.put(formData.url, formData)
    }else {
      promise =  axios.post(`${serverUrl}/company-info/`, formData)
    }
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },

  setFileCompanyInfo(context, { url, formData }) {
    let promise = null
    promise =  axios.put(`${url}set_file/`, formData, {
      headers: {'Content-Type': 'multipart/form-data'}
    })
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },
}